import {createRouter, createWebHistory} from 'vue-router'

import LandingView from '@/views/LandingView.vue'



const routes = [
    {path: '/', name: 'landing', component: LandingView},
    {path: '/:pathMatch(.*)*', name: 'page 404', component: LandingView},

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        /*Scroll To Saved Position*/
        if (savedPosition) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve({
                        top: savedPosition.top,
                        behavior: 'smooth',
                    })
                }, 400)
            })
        }
        /*Scroll To Hash*/
        if (to.hash) {
            return {
                el: to.hash,
                // selector: to.hash,
                behavior: 'smooth',
                // top: 180,
                top: 250
            }
        }
        /*Scroll To Top (Default)*/
        return {
            top: 0,
            behavior: 'smooth',
        }
    },
})
export default router
